import { render } from "./AddShoppingCartView.vue?vue&type=template&id=2dce15cc&ts=true"
import script from "./AddShoppingCartView.vue?vue&type=script&lang=ts"
export * from "./AddShoppingCartView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__